
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifistrengt3Google as ObiWifistrengt3GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifistrengt-3-google.js';
 
 
 

 
 export const ObiWifistrengt3Google = createComponent({
   react: React,
   tagName: 'obi-wifistrengt-3-google',
   elementClass: ObiWifistrengt3GoogleElement,
   events: {
     
   }
  });
 
 